import { Loader } from "rsuite";

export const SpinLoader = () => (
  <div className="spin-loader-container">
    <Loader center />
  </div>
);
